angular.module('st')
    .filter('startFrom', function() {
        return function(input, start) {
            start = +start;
            return input.slice(start);
        };
    })
    .controller('crewardsVipSubscriptionManagerController', [
        '$rootScope', '$scope', '$http', '$sce', '$filter', '$q', '$window',
        function($rootScope, $scope, $http, $sce, $filter, $q, $window) {
            var ctrl = this;
            ctrl.unlinkMemberCardNumber = null;
            ctrl.unlinkMemberEmail = null;
            ctrl.unlinkExternalMemberEmail = null;
            ctrl.nicknameMemberCardNumber = null;
            ctrl.nicknameMemberNickname = null;
            ctrl.processing = false;

            $scope.$watch(
                function () {
                    return $window.MEMBER_CARD_NUMBER 
                }, function(n,o){
                    if (n) {
                        ctrl.member_card_number = n;
                        $(function () {
                              $('[data-toggle="tooltip"]').tooltip()
                        });
                    }
                }
            );

            ctrl.SetModel = function (data) {
                $scope.model = data;
            }            

            ctrl.nicknamePrep = function (cardNumber, nickname) {
                $scope.errorMessage = null;
                ctrl.nicknameMemberCardNumber = cardNumber;
                ctrl.nicknameMemberNickname = nickname;
            }

            ctrl.unlinkPrep = function (cardNumber, email) {
                ctrl.unlinkMemberCardNumber = cardNumber;
                ctrl.unlinkMemberEmail = email;
            }

            ctrl.unlinkExternalPrep = function (email) {
                ctrl.unlinkExternalMemberEmail = email;
            }

            ctrl.unlinkExternal = function (externalEmail) {
                $scope.processing = true;
                $http.get(`/rpc/associated-members/remove-member-from-my-account/${externalEmail}`)
                    .then(function (data) {
                        if (data.data.Success == true) {
                            $scope.processing = false;
                            $scope.errorMessage2 = ''; 
                            ctrl.RemoveCardFromMyModel(externalEmail);
                            $('#linkedExternalModal').modal('hide');
                            ctrl.unlinkExternalMemberEmail = null;
                        } else {
                            // vista error
                            $scope.processing = false;
                            $scope.errorMessage2 = 'Error: ' + data.data.Message;
                        }
                    }).catch(function (error) {
                        // our server error
                        $scope.processing = false;
                        $scope.errorMessage2 = 'Error occurred while trying to remove this card.'
                    })
            }

            ctrl.updateNickName = function () {
                var cardnumber = ctrl.nicknameMemberCardNumber;
                var nickname = ctrl.nicknameMemberNickname;

                if ($scope.processing) {
                    return;
                }

                $scope.processing = true;

                updatenickName(cardnumber, nickname)
                    .then(function(response) {
                        if (response && response.data) {
                            ctrl.loadingmore = false;
                            var r = response.data;
                            if (r.Success) {
                                $scope.processing = false;
                                $scope.errorMessage = '';
                                
                                $scope.model.associatedMembers.forEach(function(m) { 
                                    if (m.cardNumber === cardnumber) {
                                        m.nickname = r.Message;
                                    }
                                });

                                $('#nicknameModal').modal('hide');
                                ctrl.nicknameMemberCardNumber = null;
                                ctrl.nicknameMemberNickname = null;
                            } else {
                                // vista error
                                $scope.processing = false;
                                $scope.errorMessage = 'Error: ' + r.Message;
                            }
                        }
                    })
                    .catch(function(response) {
                        // our server error
                        $scope.processing = false;
                        $scope.errorMessage = 'Error occurred while trying to update this nickname.'
                    })
                    .finally(function(response) {
                    });
            }

            ctrl.unlink = function (cardNumber) {

                $scope.processing = true;
                $http.get(`/rpc/associated-members/remove-member-from-account/${cardNumber}`)
                    .then(function (data) {
                        if (data.data.Success == true) {
                            $scope.processing = false;
                            $scope.errorMessage = ''; 
                            ctrl.RemoveCardFromModel(cardNumber);
                            $('#linkedModal').modal('hide');
                            ctrl.unlinkMemberCardNumber = null;
                            ctrl.unlinkMemberEmail = null;
                        } else {
                            // vista error
                            $scope.processing = false;
                            $scope.errorMessage = 'Error: ' + data.data.Message;
                        }
                    }).catch(function (error) {
                        // our server error
                        $scope.processing = false;
                        $scope.errorMessage = 'Error occurred while trying to remove this card.'
                    })
            }


            ctrl.RemoveCardFromModel = function (cardNumber) {
                for (var i = 0; i < $scope.model.associatedMembers.length; i++) {
                    if ($scope.model.associatedMembers) {
                        $scope.model.associatedMembers = $scope.model.associatedMembers.filter(member => member.cardNumber != cardNumber)
                    }
                }
                //$rootScope.$emit('cardRemoved', $scope.model.associatedMembers);
            }

            ctrl.RemoveCardFromMyModel = function (externalemail) {
                for (var i = 0; i < $scope.model.linkedEmails.length; i++) {
                    if ($scope.model.linkedEmails) {
                        $scope.model.linkedEmails = $scope.model.linkedEmails.filter(email => email != externalemail)
                    }
                }
                //$rootScope.$emit('cardRemoved', $scope.model.associatedMembers);
            }

            ctrl.linkAccount = function () {
                $scope.errorMessage = '';
                $scope.processing = true;

                if (!ctrl.newCardNumber) {
                    $scope.errorMessage = "You must enter a card number to link an account";
                    $scope.processing = false;
                    return;
                }

                if (!ctrl.newEmail || !/(.+)@(.+){2,}\.(.+){2,}/.test(ctrl.newEmail)) {
                    $scope.errorMessage = "You must enter a valid email to link an account";
                    $scope.processing = false;
                    return;
                }

                $http.post('/rpc/associated-members/add-member-to-account', {
                    cardNumber: ctrl.newCardNumber,
                    email: ctrl.newEmail
                })
                    .then(function (response) {
                        const data = response.data;
                        if (data.Success === true) {
                            $scope.processing = false;
                            $scope.feedback = '';
                            const member = data.Data;
                            const mappedMember = {
                                cardNumber: member.CardNumber,
                                quantityAvailable: member.QuantityAvailable,
                                vipPoints: member.VIPPoints
                            };
                            console.log('mappedMember', mappedMember);
                            $scope.model.associatedMembers.push(mappedMember);
                        } else {
                            $scope.processing = false;
                            $scope.errorMessage = 'Error: ' + data.Message;
                        }
                    })
                    .catch(function (error) {
                        $scope.processing = false;
                        $scope.feedback = 'Error occurred while trying to link this credit card.';
                    });
            };


            function updatenickName(cardnumberparam, nicknameparam) {
                cardnumberparam = cardnumberparam || "";
                nicknameparam = nicknameparam || "";

                var config = {
                        cardnumber: cardnumberparam,
                        nickname: nicknameparam
                };
                var deferred = $q.defer();
                
                $http.post("/rpc/associated-members/update-member-nickname", config).then(deferred.resolve);
                return deferred.promise;
            }
        }
    ]);